import React from "react";
import { Card } from "react-bootstrap";
import { ChevronDown } from "react-bootstrap-icons";

export function CollapsibleAgentPanel({
  title,
  subtitle,
  summary,
  badge,
  isCollapsed,
  onToggleCollapse,
  borderVariant = "success",
  backgroundVariant = "tertiary-bg",
  className = "shadow-sm overflow-hidden",
  children,
}) {
  return (
    <Card className={className}>
      <Card.Header
        role="button"
        tabIndex={0}
        aria-expanded={!isCollapsed}
        onClick={onToggleCollapse}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggleCollapse();
          }
        }}
        className="d-flex align-items-center gap-3 border-bottom-0 user-select-none"
        style={{
          cursor: "pointer",
          borderLeft: `3px solid var(--bs-${borderVariant})`,
          backgroundColor: `var(--bs-${backgroundVariant})`,
        }}
      >
        <ChevronDown
          size={14}
          className="flex-shrink-0 text-secondary"
          style={{
            transition: "transform .15s",
            transform: isCollapsed ? "rotate(-90deg)" : "none",
          }}
        />
        <div className="flex-grow-1 min-w-0">
          <h2 className="h6 fw-semibold mb-0 text-truncate">{title}</h2>
          {subtitle ? <p className="small mb-0 mt-1">{subtitle}</p> : null}
        </div>
        {badge ? <div className="flex-shrink-0">{badge}</div> : null}
        {summary ? (
          <div className="text-end flex-shrink-0">{summary}</div>
        ) : null}
      </Card.Header>

      {!isCollapsed && children}
    </Card>
  );
}
